<template>
  <base-list-overview
    controller="Monitor"
    :filter="Filter"
    link-controller="Child/Monitor"
    :link-key="link.key"
    link-table
    redirect
    redirect-page="Monitors"
    :rights="Rights"
    tab="monitors"
    type="monitor"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'ChildrenMonitors',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ],
  data () {
    return {
      link: {
        key: 'idChild'
      }
    }
  },
  computed: {
    Filter () {
      return [
        {
          key: this.link.key,
          value: this.ContentMixin_Element[this.link.key]
        }
      ]
    },
    Rights () {
      return this.AuthenticationMixin_UserIsAdministrator() || this.AuthenticationMixin_UserIsCarePartner() ? {
        allowCreate: true,
        allowDelete: true,
        allowRead: true,
        allowUpdate: true
      } : null
    }
  }
}
</script>
